import { render, staticRenderFns } from "./Sirens.vue?vue&type=template&id=268b352d"
import script from "./Sirens.vue?vue&type=script&lang=js"
export * from "./Sirens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports